import {PAdbContext} from "../PA.Core/PAdbContext";
import {AuditService} from "../PA.Core/Security/AuditService";
import {BaseLnBO} from "./BaseLnBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {esWB_Source} from "../PA.Core/PAdbSchema";


export class BaseLnBOAudit {


    static async BaselineAuditBO(BaseLnBO: BaseLnBO): Promise<AuditService> {

        const self = BaseLnBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("BaseLine", self.drWB_BaseLn.cif.WB_BASELINE_ID)

        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys

        const baselineParams: IAuditField [] = [
            {fieldName: "BASELINE_NAME",              realName: "Name", bAllMsg: true }, //create
            {fieldName: "BASELINE_ID",                realName: "ID",  bAllMsg: true }, //create
            {fieldName: "BASELINE_TYPE_ID",  realName: "Baseline Type", domainId:"Baseline_Type" },
            {fieldName: "SOURCE_ID",  realName: "Source", fkMapper: esWB_Source, fkMapperNameField: "SOURCE_NAME"},
            {fieldName: "MANUAL_IND",        realName: "Manual"},
            {fieldName: "WB_CUST_ID",          realName: "Customer", ...auditFieldFK.customer},
            {fieldName: "WB_PERIOD_ID",         realName: "Period", ...auditFieldFK.period},
            {fieldName: "LOAD_DT",       realName: "Load Date"},
            {fieldName: "LOAD_STATUS_ID",         realName: "Load Status", domainId: "Load_Status"},
            {fieldName: "HIST_DATATHRU_DT",          realName: "History Data Thru Date"},

        ]

        // Execute Audit Logging
        await AuditUtils.logRecord(auditService, self.WB_BaseLn, baselineParams, {objectName: 'BaseLine', deletedKeys: deleteKeys})


        return auditService
    }



}
